import ReactGA from 'react-ga'
import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { Icon } from './'
import { FlexWrapper } from './StyledComponents'

const ButtonWrapper = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: ${props => {
    switch (props.size) {
      case 'small':
        return 'auto'
      default:
        return '100%'
    }
  }};
  padding: ${props => (props.padding ? props.padding : '0 40px')};
  height: 52px;
  border-radius: 100px;
  font-size: ${props => (props.fontSize ? props.fontSize : '18px')};
  line-height: 1.56;
  margin: ${props => (props.margin ? props.margin : '0')};
  &:focus {
    box-shadow: 0 0 0 3px #fff, 0 0 0 5px ${props => (props.bgColor ? props.bgColor : '#124b5f')};
  }
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  box-shadow: ${props => (props.disabled ? '0 3px 6px 0 rgba(0, 0, 0, 0.16)' : 'none')};
  ${props =>
    props.disabled
      ? `
      background-color: #a0b7bf !important;
      border: none;
      color: #fff;
    `
      : props.volume === 'filled'
      ? `
        background-color: #124b5f;
        color: #ffffff;
        border: none;
      `
      : `
    background-color: #f7f1e3;
    border: 1px solid #124b5f;
    font-weight: 500;
    letter-spacing: normal;
    color: #124b5f;
    `};
  background: ${props => props.bgColor || props.bgColor};
  ${props =>
    props.social &&
    `
  font-family:'Chivo';
  font-size: 16px;
  text-align: left;
  padding: 0 20px;
  justify-content: flex-start;

  `};
  ${props =>
    props.orderNow &&
    `
  height: 48px;
  border: 1px solid #078489;
  border-radius: 100px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  font-size: 15px;
  font-weight: normal;
  line-height: 1.53;
  color: #078489;
  &:focus {
    box-shadow: 0 0 0 3px #fff, 0 0 0 5px #078489;
  }
  `};
  ${props =>
    props.scanNow &&
    `
  height: 48px;
  border: 1px solid #124b5f;
  border-radius: 100px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  font-size: 18px;
  font-weight: normal;
  line-height: 1.56;
  color: #124b5f;
  &:focus {
    box-shadow: 0 0 0 3px #fff, 0 0 0 5px #124b5f;
  }
  `};
  span {
    padding-right: 6px;
  }
  text-align: center;
  vertical-align: middle;
  ${props =>
    props.logout &&
    `
  height: 48px;
  border: 1px solid #eb2121;
  border-radius: 100px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: transparent;
  font-size: 18px;
  font-weight: normal;
  line-height: 1.56;
  color: #eb2121;
  &:focus {
    box-shadow: 0 0 0 3px #fff, 0 0 0 5px #eb2121;
  }
  `};
  &:hover {
    cursor: pointer;
  }
`
const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`
const spin = keyframes`
0% { transform: rotate(0deg) }
100% {transform: rotate(360deg) }
`
const Circle = styled.div`
  border: 3px solid ${props => (props.loadingBgColor ? props.loadingBgColor : '#fff')};
  border-top: 3px solid ${props => (props.loadingFgColor ? props.loadingFgColor : '#124b5f')};
  border-radius: 50%;
  margin: auto;
  width: 20px;
  height: 20px;
  animation: ${spin} 2s linear infinite;
`

class Button extends Component {
  static defaultProps = {
    onClick: () => {},
    label: 'default',
    namespace: 'default'
  }

  trackButtonClick = () => {
    this.props.onClick()
    ReactGA.event({
      category: this.props.namespace,
      action: 'Button Clicked',
      label: this.props.label,
      nonInteraction: true
    })
  }
  render() {
    const {
      size,
      social,
      color,
      volume,
      onClick,
      label,
      isLoading,
      bgColor,
      disabled,
      icon,
      image,
      logout,
      iconHeight,
      padding,
      iconWidth,
      fontSize,
      ...props
    } = this.props
    return (
      <ButtonWrapper
        volume={volume}
        bgColor={bgColor}
        size={size}
        disabled={disabled}
        padding={padding}
        social={social}
        logout={logout}
        fontSize={fontSize}
        onClick={this.trackButtonClick}
        {...props}>
        {social ? (
          <React.Fragment>
            <IconWrapper>
              <Icon icon={icon} color={color} height={iconHeight} width={iconWidth} />
            </IconWrapper>
            {label}
          </React.Fragment>
        ) : isLoading ? (
          <Circle />
        ) : image ? (
          <FlexWrapper direction="row-reverse" alignItems="center" justifyContent="center">
            {image}
            <span>{label}</span>
          </FlexWrapper>
        ) : (
          label
        )}
      </ButtonWrapper>
    )
  }
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js